import { Injectable } from '@angular/core';
import { MatLegacyPaginatorIntl as MatPaginatorIntl } from '@angular/material/legacy-paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable()
export class DynamicPaginatorIntl extends MatPaginatorIntl {
  override changes = new Subject<void>();

  constructor(private translateService: TranslateService) {
    super();
    
    // Initialize with current language
    this.updateLabels();
    
    // Listen for language changes
    this.translateService.onLangChange.subscribe(() => {
      this.updateLabels();
    });
  }

  private updateLabels(): void {
    this.translateService.get('pagination').subscribe((translations: any) => {
      this.itemsPerPageLabel = translations.items_per_page || 'Items per page:';
      this.nextPageLabel = translations.next_page || 'Next page';
      this.previousPageLabel = translations.previous_page || 'Previous page';
      
      // Update the range label function
      this.getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
          return translations.range_label?.replace('{{start}} - {{end}}', '0').replace('{{total}}', length.toString()) || `0 of ${length}`;
        }
        
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ?
          Math.min(startIndex + pageSize, length) :
          startIndex + pageSize;

        return translations.range_label
          ?.replace('{{start}}', (startIndex + 1).toString())
          ?.replace('{{end}}', endIndex.toString())
          ?.replace('{{total}}', length.toString()) || 
          `${startIndex + 1} - ${endIndex} of ${length}`;
      };
      
      // Notify that labels have changed
      this.changes.next();
    });
  }
}
